import _ from 'lodash'
import Cookie from 'js-cookie'
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import lang from 'lang'
import { validateField, validateFields } from 'common/validator'
import { httpRequest } from 'services/saga'
import { getApiUrl } from 'services/selectors'
import { requests } from 'common/requests'
import { translateResponseError } from 'common/utils'

import {
  addFieldError,
  clearFieldError,
  REGISTER_REQUEST,
  registerFailure,
  registerSuccess,
  VALIDATE_REGISTER_FIELD,
} from './actions'

function* registerSaga(action: {
  payload: {
    fullName: { value: string }
    email: { value: string }
    password: { value: string }
    registrationCode: { value: string }
  }
}): Generator<unknown, void, unknown> {
  const payload = action.payload
  const errors = validateFields(
    payload as unknown as Parameters<typeof validateFields>[0],
  ) as Record<string, string | undefined>
  if (_.isEmpty(errors)) {
    const apiUrl = (yield select(getApiUrl)) as string
    try {
      const res = yield call(httpRequest, {
        req: requests.post,
        url: apiUrl + '/rpc/signup',
        headers: { Prefer: 'params=single-object' },
        data: {
          name: payload.fullName.value,
          email: payload.email.value,
          password: payload.password.value,
          registration_code: payload.registrationCode.value,
        },
      })
      const data = (res as { data: { token: string } }).data
      Cookie.set('ruler-jwt', data.token)
      yield put(registerSuccess(data))
      yield call(() => {
        window.location.href = '/dashboard'
      })
    } catch (error: unknown) {
      yield put(
        registerFailure({
          base: translateResponseError(
            error as Parameters<typeof translateResponseError>[0],
            lang.auth.register,
          ),
        }),
      )
    }
  } else {
    yield put(registerFailure(errors as Record<string, string>))
  }
}

export function* validateFieldSaga(action: {
  payload: { field: string; value: string; validations?: string }
}): Generator<unknown, void, unknown> {
  const { field, value, validations } = action.payload
  const error = validateField({ field, value, fieldValidations: validations ?? '' })
  const errorStr = typeof error === 'string' ? error : error != null ? String(error) : undefined
  if (errorStr) yield put(addFieldError({ field, error: errorStr }))
  else yield put(clearFieldError({ field }))
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    takeLatest(REGISTER_REQUEST, registerSaga as (a: unknown) => Generator),
    takeEvery(VALIDATE_REGISTER_FIELD, validateFieldSaga as (a: unknown) => Generator),
  ])
}
